import { DayNameType } from '@account_module/types/Date';

export const DAY_NAME_MAPPER: { [key: number]: string } = {
  0: 'Sunday' as DayNameType,
  1: 'Monday' as DayNameType,
  2: 'Tuesday' as DayNameType,
  3: 'Wednesday' as DayNameType,
  4: 'Thursday' as DayNameType,
  5: 'Friday' as DayNameType,
  6: 'Saturday' as DayNameType,
};
